import React from 'react'
import Example from 'components/Example'
import FeedbackButton from 'components/FeedbackButton'
import Sector from 'components/Sector'
import bem from 'bem'
import css from './Examples.module.scss'

const b = bem.examples(css)

const Examples = () => {
	return (
		<div className={b()}>
			<Sector title="Скачать примеры" color="gray" titleCentered>
				<p className="fs-h4 text-center mb">Результаты сохранены в excel-формате</p>
				<div className={b('files', 'mb-lg')}>
					<div className={b('file')}>
						<Example
							icon="excel"
							url="/s/examples/kirelis.ru.xlsx"
							title="kirelis.ru"
							description="Товары интернет-магазина технических изделий &laquo;Кирелис&raquo;"
							tag="a"
						/>
					</div>
					<div className={b('file')}>
						<Example
							icon="excel"
							url="/s/examples/reestr.nostroy.ru.xlsx"
							title="nostroy.ru"
							description="Саморегулируемые организации из реестра &laquo;Нострой&raquo;"
							tag="a"
						/>
					</div>
					<div className={b('file')}>
						<Example
							icon="excel"
							url="/s/examples/reestr.rgr.ru.xlsx"
							title="rgr.ru"
							description="Аттестованные риэлторы из реестра российской гильдии риэлторов"
							tag="a"
						/>
					</div>
					<div className={b('file')}>
						<Example
							icon="excel"
							url="/s/examples/tourism.fsa.gov.ru.xlsx"
							title="fsa.gov.ru"
							description="Туристические объекты из национальной системы аккредитации"
							tag="a"
						/>
					</div>
				</div>
				<p className="fs-h4 text-center mb">Сайты клиентов</p>
				<div className={b('sites', 'mb-lg')}>
					<div className={b('site')}>
						<Example
							icon="amirat"
							url="https://amirat.ru"
							title="Поставщик оборудования для благоустройства"
							description="Спарсили товары от более 35 производителей спортивного оборудования для формирования каталога"
							type="inline"
							tag="pseudo-link"
						/>
					</div>
					<div className={b('site')}>
						<Example
							icon="vmebel"
							url="https://xn----7sbebfgjb8cgik1oza2b.xn--p1ai/"
							title="Интернет-магазин мебели от производителя"
							description="Спарсили товары производителя мебели для создания интернет-магазина официального дилера"
							type="inline"
							tag="pseudo-link"
						/>
					</div>
				</div>
				<div className="text-center">
					<FeedbackButton theme="primary" size="lg">
						Заказать парсинг
					</FeedbackButton>
				</div>
			</Sector>
		</div>
	)
}

export default Examples
